import React, { useEffect, useRef } from "react";

const VideoRoom = ({ patientDetails, turnConfig, socket, doctorSocketId }) => {
  const localVideoRef = useRef(null); // Reference for local video element
  const remoteVideoRef = useRef(null); // Reference for remote video element

  useEffect(() => {
    const peerConnection = new RTCPeerConnection(turnConfig);

    // Access local media
    const getLocalStream = async () => {
      try {
        const localStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        if (localVideoRef.current) {
          localVideoRef.current.srcObject = localStream;
        }

        // Add local stream tracks to PeerConnection
        localStream.getTracks().forEach((track) => {
          peerConnection.addTrack(track, localStream);
        });
      } catch (error) {
        console.error("Error accessing camera/microphone:", error.message);
        alert("Please allow access to your camera and microphone.");
      }
    };

    getLocalStream();

    // Handle ICE candidates
    peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        console.log("Generated ICE Candidate:", event.candidate);
        console.log("Doctor Socket ID:", doctorSocketId);
        socket.emit("signal", {
          to: doctorSocketId, // Use the correct recipient's socket ID
          roomId: patientDetails.room_id, // Dynamically use the room ID
          signalData: event.candidate,
        });
      }
      else
      {
        console.log("onicecandidate event in else part:", event);
      }
    };

    // Handle remote stream
    peerConnection.ontrack = (event) => {
      console.log("Received remote stream:", event.streams[0]);
      if (remoteVideoRef.current) {
        remoteVideoRef.current.srcObject = event.streams[0];
      }
    };

    // Listen for SDP offer from the doctor
    socket.on("signal", async ({ signalData }) => {
      if (signalData.type === "offer") {
        try {
          console.log("Received SDP Offer:", signalData);
          await peerConnection.setRemoteDescription(new RTCSessionDescription(signalData));

          // Create and send SDP answer
          const answer = await peerConnection.createAnswer();
          await peerConnection.setLocalDescription(answer);

          console.log("Sending SDP Answer:", answer);
          socket.emit("signal", {
            to: "doctor", // Use the doctor's socket ID
            roomId: patientDetails.room_id, // Dynamically use the room ID
            signalData: peerConnection.localDescription,
          });
          console.log("Sent SDP answer:", peerConnection.localDescription);
        } catch (error) {
          console.error("Error handling SDP offer:", error.message);
        }
      }

      if (signalData.candidate) {
        try {
          console.log("Received ICE Candidate:", signalData);
          await peerConnection.addIceCandidate(new RTCIceCandidate(signalData));
        } catch (error) {
          console.error("Error adding ICE candidate:", error.message);
        }
      }
    });

    // Cleanup on component unmount
    return () => {
      console.log("Cleaning up PeerConnection and event listeners...");
      peerConnection.close();
      socket.off("signal");
    };
  }, [patientDetails, turnConfig, socket]);

  return (
    <div>
      <h2>Video Room</h2>
      <video
        id="localVideo"
        ref={localVideoRef}
        autoPlay
        playsInline
        muted
        style={{ width: "45%", marginRight: "10px", border: "2px solid gray" }}
      ></video>
      <video
        id="remoteVideo"
        ref={remoteVideoRef}
        autoPlay
        playsInline
        style={{ width: "45%", border: "2px solid gray" }}
      ></video>
    </div>
  );
};

export default VideoRoom;
